import { render, staticRenderFns } from "./positionModal.vue?vue&type=template&id=5a12e077&scoped=true"
import script from "./positionModal.vue?vue&type=script&lang=js"
export * from "./positionModal.vue?vue&type=script&lang=js"
import style0 from "./positionModal.vue?vue&type=style&index=0&id=5a12e077&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a12e077",
  null
  
)

export default component.exports